
































import Sign from '@/servers/modules/signinsignup';
import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import NProgress from 'nprogress';
import MyNav from '@/components/skeleton/top.vue'; // 骨架结构顶部
import {
  Button, DatePicker, Form, FormItem, Input, Message, Option, Scrollbar, Select, Loading,
} from 'element-ui';
import log from '../../servers/modules/vocabulary/log';

    @Component({
      components: {
        MyNav,
        Button,
        Scrollbar,
        Form,
        FormItem,
        Input,
        Select,
        Option,
        Loading,
        DatePicker,
      },
    })
export default class extends Vue {
        @Getter public navData: any;

        @Getter public skeleton: any;

        @Mutation public setSkeletonDescribe;

        @Mutation public openDialog;

        @Mutation public closeDialog;

        private form: any = {
          loginName: '',
          oldPassword: '',
          password: '',
          password1: '',
        };

        // 原密码查看密码
        private isSeePassword: boolean = false;

        private get passwordType() {
          return !this.isSeePassword ? 'password' : 'text';
        }

        // 查看密码图标地址
        private get seePasswordUrl() {
          return !this.isSeePassword ? require('@/assets/images/person/icon/unlock.png') : require('@/assets/images/person/icon/lock.png');
        }

        // 查看密码
        private seePassword() {
          this.isSeePassword = !this.isSeePassword;
        }

        // 新密码查看密码
        private isSeePasswordNew: boolean = false;

        private get passwordTypeNew() {
          return !this.isSeePasswordNew ? 'password' : 'text';
        }

        // 查看密码图标地址
        private get seePasswordUrlNew() {
          return !this.isSeePasswordNew ? require('@/assets/images/person/icon/unlock.png') : require('@/assets/images/person/icon/lock.png');
        }

        // 查看密码
        private seePasswordNew() {
          this.isSeePasswordNew = !this.isSeePasswordNew;
        }

        private loginName : string = window.LS.get('basicData').loginName;

        created() {
          this.queryUpdateUserMes();
        }

        async queryUpdateUserMes() {
          const res = await Sign.queryUpdateUserMes().then((res) => {
            this.form.loginName = res.data.data.loginName;
          });
        }

        private async dialogHandle() {
          const loading = Loading.service({ fullscreen: true, lock: true, text: '正在退出中' });
          const res = await Sign.logout().finally((e) => {
            loading.close();
          });
          if (!res.data.code) {
            window.LS.clear();
            this.$router.replace('/login');
          }
        }

        private async updateUserInfo() {
          if (this.form.password == this.form.password1 && this.form.password && this.form.password1) {
            const res = await Sign.updatePassword(this.form);
            if (!res.data.code) {
              Message.success('修改密码成功');
              this.dialogHandle();
              this.form = {};
            } else {
              Message.error('修改密码失败');
            }
          } else {
            Message.error('两次密码不一致');
          }
        }
}
